// Blocks angle-bracket characters so form values can't carry HTML/script tags
// (e.g. `<script>`, `<img onerror=...>`) into stored data or downstream renders.
export const NO_HTML_REGEX = /^[^<>]*$/;

export const noHtmlMessage = (fieldLabel) => `${fieldLabel} is not valid`;

export const stripHtmlTags = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  return value.replace(/<[^>]*>/g, "").trim();
};

export const containsHtml = (value) => {
  if (typeof value !== "string") {
    return false;
  }

  return /[<>]/.test(value);
};
